/**
 * Incident Notification Recipients Service
 * HTTP operations for incident notification recipients catalog
 */

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type {
  LC_GetIncidentNotificationRecipientsOut,
  IncidentNotificationRecipient,
} from './incidentNotificationRecipients.types';
import { mapIncidentNotificationRecipients } from './incidentNotificationRecipients.mapper';


export class IncidentNotificationRecipientsService {
  /**
   * Get incident notification recipients catalog
   * GET /v{version}/catalog/incident-notification-recipients
   */
  async getRecipients(): Promise<ApiResponse<IncidentNotificationRecipient[]>> {
    const endpoint = API_CONFIG.ENDPOINTS.CATALOG.INCIDENT_NOTIFICATION_RECIPIENTS;
    const response = await apiClient.get<LC_GetIncidentNotificationRecipientsOut>(endpoint);

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapIncidentNotificationRecipients(response.data) };
  }
}

export const incidentNotificationRecipientsService = new IncidentNotificationRecipientsService();
